/** Notas de entrada cujos contextos do modal de vínculo devem vir numa chamada (painel da NF no card). */
export class NotaFiscalEntradaContextosVinculoPedidoRequest {
  idsNFeEntrada: number[] = [];
}
